'use es6';

const pauseReduxDebuggingMiddleware = () => next => action => {
  if (window.HS_PAUSE_REDUX) {
    return next({
      type: 'dummy-action'
    });
  }
  return next(action);
};
export default pauseReduxDebuggingMiddleware;